import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const {
    t,
    coverImage
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -80
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1]
  }} className={`
        fixed top-0 left-0 right-0 z-50
        transition-all duration-500
        ${scrolled ? 'bg-void/80 backdrop-blur-xl border-b border-flame/10' : 'bg-transparent'}
      `} data-id="element-213">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between" data-id="element-214">
        <a href="#" className="flex items-center gap-3 group" data-id="element-215">
          <div className="relative" data-id="element-216">
            <div className="absolute -inset-1 bg-gradient-to-r from-flame/30 via-magenta/20 to-teal/30 rounded-lg blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-217" />
            <img src={coverImage} alt="DMT Logo" loading="eager" decoding="async" className="relative h-10 w-auto rounded-md shadow-sm" data-id="element-218" />
          </div>
          <div className="hidden sm:flex flex-col" data-id="element-219">
            <span className="font-serif text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-gold via-flame-light to-gold tracking-wider leading-tight" data-id="element-220">
              DMT
            </span>
            <span className="text-white/40 text-[10px] font-sans tracking-widest uppercase" data-id="element-221">
              {t('nav.subtitle')}
            </span>
          </div>
        </a>

        <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: scrolled ? 1 : 0,
        y: scrolled ? 0 : -8
      }} transition={{
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className={`flex items-center gap-8 pointer-events-${scrolled ? 'auto' : 'none'}`} data-id="element-222">
          <a href="#libro" className="font-sans text-sm text-white/60 hover:text-flame-light transition-colors duration-300 tracking-wide" data-id="element-223">
            {t('nav.book')}
          </a>
          <a href="#autores" className="font-sans text-sm text-white/60 hover:text-flame-light transition-colors duration-300 tracking-wide" data-id="element-224">
            {t('nav.authors')}
          </a>
        </motion.div>
      </div>
    </motion.nav>;
}